import React from 'react'
import { useTranslation, Trans } from 'react-i18next'

import EMAILS from 'common/constants/emails'

import { getFullUrlToSsr } from 'utils/router'

import Block from '../../components/Block/Block'

import image1 from './i/image1.png'
import image2 from './i/image2.png'

import styles from './WhatIsNext.module.scss'

const WhatIsNext = ({ onFeedback }) => {
    const { t } = useTranslation()

    return (
        <>
            <Block
                image={image1}
                article={
                    <>
                        ✔️&nbsp;&nbsp;
                        {t(
                            'Tomorrow we will send you the 1st of 3 lessons on email. Don’t worry, we will not send tons of marketing stuff, just lessons.',
                        )}
                        <br />
                        <br />
                        ✔️&nbsp;&nbsp;
                        {t(
                            'Next 3 emails you will know how to create interactive education materials and how teachers create content and engage their students for FREE.',
                        )}
                        <br />
                        <br />
                        ✔️&nbsp;&nbsp;
                        {t(
                            'You will know how to embed projects in LMS, collaborate with colleagues and students and become a master in project creation!',
                        )}
                        <br />
                        <br />
                        <Trans
                            i18nKey="Don’t want to wait for them? <lnk>Visit our Help Center</lnk>"
                            components={{
                                lnk: <a href="https://help.interacty.me" target="_blank" />,
                            }}
                        />
                    </>
                }
            />
            <Block
                image={image2}
                title={t('What to do now?')}
                article={
                    <>
                        <Trans
                            i18nKey="Explore <lnk>education templates</lnk>. Select any template and click “Edit”. Change any text/image you want and click “Publish”<br/>Copy project link and try if this is accessible from your phone!"
                            components={{
                                lnk: <a href={getFullUrlToSsr('/template-gallery/tags/education')} target="_blank" />,
                            }}
                        />
                        <br />
                        <br />
                        <Trans
                            i18nKey="Visit and explore our <lnk>Youtube channel</lnk>"
                            components={{
                                lnk: (
                                    <a
                                        href="https://www.youtube.com/channel/UCsXVopApOxKt0b9JIkkhZog/videos"
                                        target="_blank"
                                    />
                                ),
                            }}
                        />
                        <br />
                        <br />
                        <Trans
                            i18nKey="Do you have questions? <email>Write us</email>"
                            components={{
                                email: <a href={`mailto:${EMAILS.INTERACTY_INFO}`} />,
                            }}
                        />
                        <br />
                        <br />
                        {t('Please rate tutorial to finish it')}
                        <ul className={styles.feedbackList}>
                            <li className={styles.feedbackItem} onClick={() => onFeedback(false)}>
                                👎
                            </li>
                            <li className={styles.feedbackItem} onClick={() => onFeedback(true)}>
                                👍
                            </li>
                        </ul>
                    </>
                }
            />
        </>
    )
}

export default WhatIsNext
